'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

    _this.state = { isHovering: false };
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var color = this.state.isHovering && this.props.hoverColor ? this.props.hoverColor : this.props.color;
      return _react2.default.createElement(
        'span',
        { onMouseOut: this.onMouseOut.bind(this), onMouseOver: this.onMouseOver.bind(this) },
        _react2.default.createElement(
          'svg',
          { viewBox: '-1 -1 18 12', width: '100%', height: '100%' },
          _react2.default.createElement('path', { d: 'M6.638 10.035l-.985-3.097H2.297l-.998 3.097H0L3.302 0h1.333L7.95 10.035H6.638zM5.29 5.811l-.91-2.899a19.485 19.485 0 0 1-.423-1.545c-.091.451-.196.868-.314 1.251l-.985 3.193h2.632zm9.003 4.224l-.253-1.039h-.055c-.35.442-.71.749-1.08.92-.369.17-.845.256-1.428.256-.743 0-1.325-.196-1.747-.588-.422-.392-.632-.941-.632-1.647 0-1.514 1.162-2.306 3.486-2.38l1.388-.047v-.472c0-1.075-.556-1.613-1.668-1.613-.67 0-1.418.187-2.242.56l-.431-.936c.893-.438 1.766-.656 2.618-.656 1.035 0 1.783.198 2.246.594.462.397.693 1.033.693 1.908v5.14h-.895zm-.335-3.67l-1.107.047c-.894.037-1.527.177-1.9.42-.375.244-.561.617-.561 1.118 0 .811.455 1.217 1.367 1.217.67 0 1.204-.186 1.603-.557.399-.372.598-.895.598-1.569v-.677z', fill: color })
        )
      );
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      this.setState({ isHovering: false });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.setState({ isHovering: true });
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  color: _react.PropTypes.string.isRequired,
  hoverColor: _react.PropTypes.string
};
_class.displayName = 'String';
exports.default = _class;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@segment/icons/build/react/String.js
// module id = 1091
// module chunks = 0